<template>
    <v-row class="mx-0 h-100">
        <v-col xl="3" md="4" cols="12" class="h-md-100">
            <ticket-customer-information
                @called="$refs.customerCallDialog.dialog = true"
                @deleted="makeDelete"
                :showCall="$refs.customerCallDialog && $refs.customerCallDialog.hasNumber()"
                :user="customerInformation"
                show-actions
                ref="ticketCustomerInformation"
            ></ticket-customer-information>
        </v-col>
        <v-col xl="9" md="8" cols="12" class="d-md-flex flex-md-column h-md-100">
            <v-tabs class="flex-shrink-0" color="secondary" v-model="pageTab">
                <v-tab class="text-small" value="customerEvents" v-if="$system.license.features.customer_event">تاریخچه رویدادها</v-tab>
                <v-tab class="text-small" value="customerTickets">لیست آخرین تیکت‌ها</v-tab>
                <v-tab class="text-small" value="customerTags">برچسب ها</v-tab>
                <v-tab class="text-small" value="customerCallHistory" v-if="$system.systemSettings.voip_active">تاریخچه آخرین تماس ها</v-tab>
            </v-tabs>
            <div class="px-3 bg-white flex-grow-1"></div>
            <v-tabs-window class="h-100" v-model="pageTab">
                <v-tabs-window-item class="h-100" value="customerTickets">
                    <v-data-table
                        :headers="ticketHeaders"
                        :items="customerLastTickets === false ? [] : customerLastTickets"
                        :options="{itemsPerPage: -1}"
                        :loading="customerLastTickets === false"
                        @click:row="(_, row) => $router.push({path: `/tickets/${row.item.id}`})"
                        no-data-text="موردی پیدا نشد!"
                        hide-default-footer
                        class="h-100 mt-3"
                        mobile-breakpoint="800"
                    >
                        <template #[`item.importance`]="{ item }">
                            <v-chip :color="item.importance.color" variant="flat" class="text-small justify-center rounded" style="width: 100px;">{{item.importance.name}}</v-chip>
                        </template>
                    </v-data-table>
                </v-tabs-window-item>
                <v-tabs-window-item class="h-100" value="customerCallHistory" v-if="$system.systemSettings.voip_active">
                    <v-data-table
                        :headers="callHistoryHeaders"
                        :items="customerCallHistory === false ? [] : customerCallHistory"
                        :options="{itemsPerPage: -1}"
                        :loading="customerCallHistory === false"
                        no-data-text="موردی پیدا نشد!"
                        hide-default-footer
                        class="h-100 mt-3"
                        mobile-breakpoint="800"
                    >
                        <template #[`item.status`]="{ item }">
                            <div class="rounded text-white text-center d-inline-block user-select-none text-small" style="width: 90px; padding:3px 0" :style="{backgroundColor: item.status.includes('نشده') ? '#db3a31': '#34c38f' }">{{ item.status }}</div>
                        </template>
                    </v-data-table>
                </v-tabs-window-item>
                <v-tabs-window-item class="h-100 bg-white px-2" value="customerEvents" v-if="$system.license.features.customer_event">
                    <customer-event-sidebar :user="customerInformation" :key="customerInformation"></customer-event-sidebar>
                </v-tabs-window-item>
                <v-tabs-window-item class="h-100" value="customerTags">
                    <tag-input class="mt-3 bg-white h-100 pa-3" v-model="tags" type="customer" :id="$route.params.id"></tag-input>
                </v-tabs-window-item>
            </v-tabs-window>
        </v-col>
    </v-row>
    <customer-call-dialog ref="customerCallDialog"></customer-call-dialog>
</template>

<script>
export default {
    title: "اطلاعات مشتری",
    validate(context) {
        return context.rbac.can("manage customers");
    },
    data() {
        return {
            pageTab: 'customerEvents',
            tags: [],
            customerInformation: {},
            ticketHeaders: [
                {
                    title: "شناسه",
                    value: "identifier",
                    sortable: false,
                    width: 60
                },
                {
                    title: "اهمیت",
                    value: "importance",
                    sortable: false,
                    align: "center",
                    width: 100,
                    maxWidth: 100,
                },
                {
                    title: "دسته بندی",
                    value: "ticket_category",
                    sortable: false,
                    align: "center",
                    width: 160
                },
                {
                    title: "وضعیت",
                    value: "ticketStatus",
                    sortable: false,
                    align: "center",
                    width: 95
                },
                {
                    title: "عنوان",
                    value: "title",
                    sortable: false,
                    width: 220
                },
                {
                    title: "دپارتمان گیرنده",
                    value: "to_department.name",
                    sortable: false,
                    align: "center",
                    width: 170
                },
                {
                    title: "آخرین به‌روزرسانی",
                    value: "updated_at",
                    sortable: false,
                    align: "center",
                    width: 150
                },
            ],
            callHistoryHeaders: [
                {
                    title: "شماره تماس گیرنده",
                    value: "caller_phone",
                    sortable: false,
                    width: 150
                },
                {
                    title: "نام تماس گیرنده",
                    value: "caller",
                    sortable: false,
                    width: 180
                },
                {
                    title: "شماره مخاطب",
                    value: "interphone",
                    sortable: false,
                    width: 150
                },
                {
                    title: "نام مخاطب",
                    value: "recipient",
                    sortable: false,
                    width: 180
                },
                {
                    title: "وضعیت",
                    value: "status",
                    sortable: false,
                    align: "center",
                    width: 100
                },
                {
                    title: "مدت مکالمه",
                    value: "conversation_duration",
                    sortable: false,
                    align: "center",
                    width: 100
                },
                {
                    title: "مدت انتظار",
                    value: "waiting_period",
                    sortable: false,
                    align: "center",
                    width: 100
                },
                {
                    title: "تاریخ و ساعت",
                    value: "started_at",
                    sortable: false,
                    align: "center",
                    width: 150
                },
            ],
            customerLastTickets: false,
            customerCallHistory: false,
        };
    },
    methods: {
        async makeDelete() {
            this.$confirm(
                `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، کاربر حذف خواهد شد.</p>`,
                { buttonTrueText: "حذف", buttonTrueColor: "error" }
            ).then((res) => {
                if (res){
                    this.$loading.start();
                    this.$userDelete(this.$route.params.id, 0).then((res) => {
                        if (res && res.status == "DELETED") {
                            this.$toast.success(res.message);
                            this.$router.push({path: '/customers' });
                        }
                    }).finally(()=>{this.$loading.finish()});
                }
            });
        },
        async getTicketList() {
            await this.$ticketList({
                perPage: 20,
                customer_id: this.$route.params.id,
            }).then((res) => {
                if (res && res.status == "OK") {
                    this.customerLastTickets = [...res.data];
                    this.customerLastTickets.forEach((el) => {
                        el.updated_at = this.$moment(el.updated_at).format('HH:mm jYYYY/jMM/jDD');
                        el.ticketStatus = this.$system.ticketStatuses.find(x => x.id == el.ticket_status).name;
                        el.importance = this.$system.importances.find(x => x.id == el.importance);
                        el.ticket_category = (el.ticket_category && el.ticket_category.name) || 'سایر'
                    });
                }
            });
        },
        async getCallHistory() {
            await this.$getCallHistory({
                perPage: 20,
                users: [this.$route.params.id]
            }).then(async res => {
                if (res && res.status == "OK") {
                    this.customerCallHistory = res.data;
                    this.customerCallHistory.forEach((el) => {
                        if (el.answered_at && el.started_at) {
                            let duration = Math.floor(((new Date(el.answered_at)).getTime() - (new Date(el.started_at)).getTime()) / 1000);
                            el.waiting_period = `${Math.floor(duration / 60)}:${duration % 60}`
                        } else
                            el.waiting_period = '-------';
                        if (el.answered_at && el.finished_at) {
                            let duration = Math.floor(((new Date(el.finished_at)).getTime() - (new Date(el.answered_at)).getTime()) / 1000);
                            el.conversation_duration = `${Math.floor(duration / 60)}:${duration % 60}`
                        } else
                            el.conversation_duration = '-------';
                        el.started_at = this.$moment(el.started_at).format('HH:mm jYYYY/jMM/jDD');
                        el.status = el.answered_at ? "پاسخ داده شده" : "پاسخ داده نشده";
                        el.recipient = el.recipient ? el.recipient.name : '-------';
                        el.caller = el.caller ? el.caller.name : '-------';
                    });
                }
            });
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.$userGet(this.$route.params.id, 0).then(async (res) => {
                if (res && res.status == "OK") {
                    this.customerInformation = { ...res.data };
                    this.tags = this.customerInformation.tags;
                    delete this.customerInformation.tags;
                    if(!this.$system.license.features.customer_event)
                        this.pageTab = 'customerTickets';
                    this.$refs.customerCallDialog.calculateNumbers(this.customerInformation);
                }
            });
            let promises = [this.getTicketList()];
            if (this.$system.systemSettings.voip_active)
                promises.push(this.getCallHistory())
            await Promise.all(promises);
            this.$loading.finish();
        });
    },
};
</script>
